<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="cabecera">
        <v-flex xs9> <v-icon>remove_red_eye</v-icon>Ver seguimiento </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Número:</strong>
                  {{ this.form.secuencia }}
                </h4>
              </v-flex>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Nombre:</strong>
                  {{ this.user.nombres }} {{ this.user.ap_paterno }}
                  {{ this.user.ap_materno }}
                </h4>
              </v-flex>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Cedula:</strong>
                  {{ this.user.nro_doc }}
                </h4>
              </v-flex>

              <v-flex xs12>
                <h4 class="subtitulo2"><strong>Detalle papeleta</strong></h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_papeleta"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>

                    <td class="text-xs-center">{{ props.item.total_dias }}</td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <h4 class="subtitulo2"><strong>Seguimiento papeleta</strong></h4>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_detalle"
                  class="elevation-1"
                  hide-actions
                  :headers="headers2"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.fecha_registro }}
                    </td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                    <td class="text-xs-center">{{ props.item.usuario }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> CERRAR
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      user: this.$storage.get("user"),
      form: {
        funcionario: {
          nombre: ""
        }
      },
      //url: 'vCronoVacass',
      valid: false,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      saldo: null,
      periodo: null,
      id: null,
      lista_papeleta: [],
      lista_detalle: [],
      headers: [
        { text: "Fecha salida", sortable: false, align: "center" },
        { text: "Fecha fin", sortable: false, align: "center" },
        { text: "Total días", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" }
      ],
      headers2: [
        { text: "Fecha registro", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
        { text: "Usuario", sortable: false, align: "center" }
      ]
    };
  },
  async mounted() {
    this.$bus.$on("openDialogVerDetalleRepFuncionario", async item => {
      this.form = item;
      this.form.id = parseInt(this.form.id);
      this.cargarTablaPapeleta();
      this.dialog = true;
      await this.cargarSeguimiento();
    });
  },

  methods: {
    close() {
      this.form = {
        funcionario: {
          nombre: ""
        }
      };
      this.lista_papeleta = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogVerDetalleRepFuncionario");
      this.dialog = false;
    },
    cargarTablaPapeleta() {
      this.lista_papeleta.push(this.form);
    },
    async cargarSeguimiento() {
      try {
        console.log(`
			query{
				runQuery(consulta:"select * from vacaciones.v_seguimiento_vaca_progra vsvp  where vsvp.id_vaca_progra=${parseInt(this.form.id)}"){
					respuesta
				}
				}
			`)
        let respuesta = await this.$service.graphql({
          query: `
			query{
				runQuery(consulta:"select * from vacaciones.v_seguimiento_vaca_progra vsvp  where vsvp.id_vaca_progra=${parseInt(this.form.id)}"){
					respuesta
				}
				}
			`
        });
        console.log(respuesta.runQuery.respuesta)
        let res = respuesta.runQuery.respuesta;
        this.lista_detalle = res;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style>
.titulo {
   font-size:1.07em;
  color: rgb(24, 106, 121);
  font-weight: bold;
}
.texto {
  font-size:1.07em;
 color: rgb(24, 106, 121);
}
.subtitulo2 {
  font-size: 1.35em;
  color: rgb(24, 106, 121);
}
.cabecera {
  background-color: rgba(14, 187, 178, 0.35);
  font-size: 1.5em;
  color: rgba(24, 106, 121);
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_reprogramacion/dialogs/VerDetalle.vue